import { useEffect, useRef } from 'react';
import navStore from './navStore';
import useOffset from './useOffset';

const useScrollToCurrentSection = (width: number) => {
  const ref = useRef<any>(null);
  const shouldScroll = navStore(state => state.shouldScroll);
  const currentSection = navStore(state => state.currentSection);
  const getOffset = useOffset(width);

  useEffect(() => {
    if (!shouldScroll) return;
    ref.current?.scrollTo({
      left: getOffset(currentSection),
      behavior: 'smooth',
    });
  }, [getOffset, shouldScroll, currentSection]);
  return ref;
};

export default useScrollToCurrentSection;
